// Admin and management routes module
import AttemptAuthorizations from '@/router/AttemptAuthorizations.js';
import CourseTemplates from '@/router/CourseTemplates.js';
import Dashboards from '@/router/Dashboards.js';
import EvaluationDashboard from '@/router/EvaluationDashboard.js';
import FeatureFlags from '@/router/FeatureFlags.js';
import Groups from '@/router/Groups.js';
import InstitutionSettings from '@/router/InstitutionSettings.js';
import Integrations from '@/router/Integrations.js';
import Locations from '@/router/Locations.js';
import Meetings from '@/router/Meetings.js';
import People from '@/router/People.js';
import Reports from '@/router/Reports.js';
import TermSchedule from '@/router/TermSchedule.js';
import TermTemplates from '@/router/TermTemplates.js';

export default [
    ...AttemptAuthorizations,
    ...CourseTemplates,
    ...Dashboards,
    ...EvaluationDashboard,
    ...FeatureFlags,
    ...Groups,
    ...InstitutionSettings,
    ...Locations,
    ...Meetings,
    ...People,
    ...Reports,
    ...TermSchedule,
    ...TermTemplates,
    ...Integrations,
];
